<template>
  <div>
    <section class="section">
      <transition name="fade" mode="out-in" appear>
        <div
          class="container is-widescreen"
          :key="projectId"
          v-if="project._id"
        >
          <div class="columns is-centered">
            <div class="column is-8 capsule-image">
              <figure class="image">
                <img :src="image" alt="capsule image" />
              </figure>
              <!--ImgLoader :imgUrl="image">
                <template slot="img-loading">
                  <a class="icon is-small">
                    <i class="fas fa-circle-notch fa-spin"></i>
                  </a>
                </template>
              </ImgLoader-->
            </div>
            <div class="column is-4">
              <p class="title is-size-4 has-text-left-tablet">
                {{ project.title }}
              </p>
              <div class="has-text-secondary has-text-weight-bold is-size-6">
                <ul class="menu-list">
                  <li>
                    <span
                      class="is-inline-flex-mobile is-flex-tablet project-information-item"
                    >
                      <figure class="image is-24x24">
                        <img
                          src="@/assets/project-detail-icons/sesiones@2x.png"
                        />
                      </figure>
                      <span class="icon-text">{{
                        project["session-number"]
                      }}</span>
                    </span>
                  </li>
                  <li>
                    <span
                      class="is-inline-flex-mobile is-flex-tablet project-information-item"
                    >
                      <figure class="image is-24x24">
                        <img
                          src="@/assets/project-detail-icons/duracion@2x.png"
                        />
                      </figure>
                      <span class="icon-text">{{ project["duration"] }}</span>
                    </span>
                  </li>
                  <li>
                    <span
                      class="is-inline-flex-mobile is-flex-tablet project-information-item"
                    >
                      <figure class="image is-24x24">
                        <img src="@/assets/project-detail-icons/curso@2x.png" />
                      </figure>
                      <span class="icon-text">{{ project["courses"] }}</span>
                    </span>
                  </li>
                </ul>
              </div>
              <project-downloads :files="files"></project-downloads>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <section class="section has-text-left">
      <transition
        name="custom-classes-transition"
        enter-active-class="animated slideInUp"
        leave-active-class="animated slideOutDown"
        mode="out-in"
        appear
        v-if="project._id"
      >
        <div class="container" :key="projectId">
          <div class="columns">
            <div class="column">
              <p
                class="title is-size-5 has-text-black"
                v-t="'course-information'"
              ></p>
              <p
                class="has-text-weight-light is-size-5"
                v-html="project.description"
              ></p>
              <div v-if="goals">
                <p
                  class="title has-text-left is-size-5 has-text-black"
                  style="padding-top:60px"
                  v-t="'goals'"
                ></p>
                <div class="colums is-mobile">
                  <div class="columns is-multiline" style="margin:10px">
                    <div
                      class="column is-half"
                      v-for="(goal, index) in goals"
                      :key="index"
                    >
                      <div class="media">
                        <div class="media-left is-marginless">
                          <figure class="image is-32x32">
                            <img
                              src="@/assets/project-detail-icons/check-goals@2x.png"
                              srcset="
                                @/assets/project-detail-icons/check-goals@2x.png 2x
                              "
                            />
                          </figure>
                        </div>
                        <div class="media-content">
                          <p v-html="goal" class="icon-text"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-4" v-if="capabilities">
              <p
                class="title is-size-5 has-text-black is-capitalized"
                v-t="'capabilities'"
              ></p>
              <div v-for="capability in capabilities" :key="capability">
                <span
                  class="tag is-large is-white is-rounded is-size-6 has-text-weight-bold"
                  >{{ capability }}</span
                >
              </div>
              <div>
                <capsule-partner
                  class="capsule-partner is-inline-block"
                  :inCapsule="false"
                  :partnerLogo="capsulePartner['partner-logo']"
                  :partnerURL="capsulePartner['partner-url']"
                ></capsule-partner>
              </div>
            </div>
          </div>
          <project-sessions :project-id="projectId"/>
        </div>
      </transition>
    </section>

    <section class="section has-background-pale-sky-blue">
      <AppLibraryButtonSection />
    </section>
    <CapsuleRelatedCapsules />
    <AppNewsletter />
    <AppFooter />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProjectDownloads from '@/components/ProjectDownloads'
import CapsulePartner from '@/components/CapsulePartner'
import AppNewsletter from 'mschools-components/src/components/AppNewsletter'
import CapsuleRelatedCapsules from '@/components/CapsuleRelatedCapsules'
import AppFooter from 'mschools-components/src/components/AppFooter'
import ImgLoader from '@/components/vue2-image-loader'
import AppLibraryButtonSection from '@/components/AppLibraryButtonSection'
import ProjectSessions from '@/components/ProjectSessions'
import _ from 'underscore'
export default {
  props: ['projectId', 'reference'],
  components: {
    CapsulePartner,
    AppNewsletter,
    AppFooter,
    CapsuleRelatedCapsules,
    ProjectDownloads,
    ImgLoader,
    AppLibraryButtonSection,
    ProjectSessions
  },
  data () {
    return {}
  },
  methods: {
    fetchProject: function () {
      if (this.projectId) {
        this.$store.dispatch('fetchCapsule', {
          params: { id: this.projectId }
        })
      } else {
        this.$store
          .dispatch('getProjectByLanguage', {
            language: this.$store.getters.activeLanguage,
            reference: this.reference
          })
          .then(() => {
            if (_.isEmpty(this.project)) this.$router.push('/')
          })
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: 'fetchProject'
    }
  },
  destroyed () {
    this.$store.dispatch('cleanCapsule')
  },
  computed: {
    ...mapState({
      project: function (state) {
        if (!state.capsule) return {}
        return state.capsule
      },
      loggedIn: state => state.Auth.isLoggedIn
    }),
    capabilities: function () {
      return _.toArray(this.project['capabilities']) || []
    },
    goals: function () {
      return this.project['goals'] || null
    },
    files: function () {
      return _.pick(this.project, 'student-downloads', 'teacher-downloads')
    },
    image: function () {
      return this.project.mainImage ? this.project.mainImage[0].fileUrl : ''
    },
    capsulePartner () {
      return this.$store.getters.capsulePartner(this.project._id)
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/sass/msteam-style";
section:nth-child(2n) {
  background-color: unset;
  .title {
    color: unset;
  }
}
section:nth-child(2n-1) {
  background-color: $light-grey;
}

.tag {
  border: 1px solid $nice-blue;
  color: $nice-blue !important;
  margin-top: 5px;
}
.icon-text {
  margin-left: 15px;
}
.capsule-partner {
  margin-top: 30px;
}
.icon {
  margin: auto 0;
}
.project-information-item:first-child {
  padding-top: 5px;
}
.project-information-item {
  padding-top: 12px;
}
.capsule-image {
  height: 330px;
}
.capsule-image > .image > img {
  height: 330px;
  width: 100%;
  object-fit: cover;
}

@media screen and (min-width: 768px) {
  .title {
    margin-top: 0 !important;
  }
}
</style>
